<script lang="ts">
  import { onMount } from 'svelte';

  let open = $state(false);
  let title = $state('');
  let message = $state('');
  let type = $state<'alert' | 'confirm' | 'prompt'>('alert');
  let inputValue = $state('');
  let inputAttrs = $state<Record<string, any>>({});
  let confirmText = $state('OK');
  let cancelText = $state('Cancel');
  let showCancel = $state(true);

  let resolveCurrent: ((value: any) => void) | null = null;

  onMount(() => {
    window.bulmaPrompt = (msg: string, defaultValue?: string) => {
      return new Promise((resolve) => {
        open = true;
        type = 'prompt';
        message = msg;
        inputValue = defaultValue || '';
        showCancel = true;
        confirmText = 'OK';
        cancelText = 'Cancel';
        resolveCurrent = resolve;
      });
    };
    window.bulmaAlert = (msg: string) => {
      return new Promise((resolve) => {
        open = true;
        type = 'alert';
        message = msg;
        showCancel = false;
        confirmText = 'OK';
        resolveCurrent = resolve;
      });
    };
    window.bulmaConfirm = (msg: string) => {
      return new Promise((resolve) => {
        open = true;
        type = 'confirm';
        message = msg;
        showCancel = true;
        confirmText = 'OK';
        cancelText = 'Cancel';
        resolveCurrent = resolve;
      });
    };
  });

  function handleResolve(value: any) {
    open = false;
    resolveCurrent?.(value);
    resolveCurrent = null;
  }
</script>

{#if open}
  <!-- svelte-ignore a11y_no_static_element_interactions -->
  <div class="fixed inset-0 z-[20000] flex items-center justify-center bg-black/50" onkeydown={(e) => { if (e.key === 'Escape') handleResolve(type === 'prompt' ? null : false); }}>
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div class="bg-white rounded-xl shadow-xl p-6 max-w-sm w-full mx-4" role="dialog" aria-modal="true" tabindex="-1" onclick={(e) => e.stopPropagation()}>
      {#if title}
        <h3 class="text-lg font-semibold mb-2">{title}</h3>
      {/if}
      <p class="text-gray-600 text-sm mb-4">{message}</p>
      {#if type === 'prompt'}
        <input
          bind:value={inputValue}
          class="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm mb-4 focus:border-primary-500 focus:ring-1 focus:ring-primary-500"
        />
      {/if}
      <div class="flex justify-end gap-2">
        {#if showCancel}
          <button class="px-4 py-2 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50" onclick={() => handleResolve(type === 'prompt' ? null : false)}>
            {cancelText}
          </button>
        {/if}
        <button class="px-4 py-2 text-sm rounded-md bg-primary-500 text-white hover:bg-primary-600" onclick={() => handleResolve(type === 'alert' ? undefined : type === 'confirm' ? true : inputValue)}>
          {confirmText}
        </button>
      </div>
    </div>
  </div>
{/if}
